"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CCI_URI = exports.ACCOUNT_URI = exports.SEND_PASSWORD_URI = exports.PREVIOUS_URI = exports.CHECK_ALREADY_SIGN_UP = exports.VERIFY_EMAIL_URI = exports.IDENTITY_URI = exports.AUTHENTICATION_URI = exports.CREATE_DGP_URI = exports.RENEW_OTP_URI = exports.CHECK_TOTP_URI = exports.VALIDATE_SECOND_ADHESION_URI = exports.PROCESS_CONNECT_URI = exports.VERIFICATION_URI = exports.CONTEXT_URI = exports.GET_POPULAR_DOMAIN_EMAILS = exports.ACTUATOR_HEALTH_URI = exports.INVITATION_URI = exports.SIGNUP_CALLBACK_URI = exports.AUTORIZE_URI = exports.WELCOME_URI = exports.SIGNUP_GROUP_NAME = void 0;
exports.SIGNUP_GROUP_NAME = 'signup';
exports.WELCOME_URI = 'welcome';
exports.AUTORIZE_URI = '/v3/authorize';
exports.SIGNUP_CALLBACK_URI = '/signup/process/callback';
exports.INVITATION_URI = '/invitation';
exports.ACTUATOR_HEALTH_URI = '/actuator/health';
exports.GET_POPULAR_DOMAIN_EMAILS = '/get-popular-domain-emails';
exports.CONTEXT_URI = '/context';
exports.VERIFICATION_URI = '/verification';
exports.PROCESS_CONNECT_URI = '/signup/process/connect';
exports.VALIDATE_SECOND_ADHESION_URI = '/validate-second-adhesion';
exports.CHECK_TOTP_URI = '/check-totp';
exports.RENEW_OTP_URI = '/renew-otp';
exports.CREATE_DGP_URI = '/create-dgp';
exports.AUTHENTICATION_URI = '/authentification';
exports.IDENTITY_URI = '/identity';
exports.VERIFY_EMAIL_URI = '/verify-email';
exports.CHECK_ALREADY_SIGN_UP = '/api/check-signup';
exports.PREVIOUS_URI = '/previous';
exports.SEND_PASSWORD_URI = '/send-password';
exports.ACCOUNT_URI = '/account';
exports.CCI_URI = '/api/v2/termsOfUse/current-version';
